const constants = require('./constants')
const sanitize = require('./sanitize')
const mock = require('./mock')

const ROOT_LOGGER = 'root'

const buildReference = (ref) =>
  `${constants.LOGGER_REFERENCE_PREFIX} ${ref} ${constants.LOGGER_REFERENCE_SUFFIX}`

// This requires a subclass to extend and add a _logAtLevel class to handle the log levels
class Logger {
  constructor (modReference = '') {
    // We wrap the prefix in the brackets to create a standard searchable term
    // in the logs
    this._prefix = !modReference ? '' : buildReference(modReference)
    this._loggerInstance = !modReference ? ROOT_LOGGER : modReference
  }

  debug (...args) {
    this._logAtLevel('debug', ...this._constructMessage(...args))
  }

  info (...args) {
    this._logAtLevel('info', ...this._constructMessage(...args))
  }

  warn (...args) {
    this._logAtLevel('warn', ...this._constructMessage(...args))
  }

  error (...args) {
    this._logAtLevel('error', ...this._constructMessage(...args))
  }

  // The common case, and the one that we have to support because of backwards compatability, is just using the root
  // logger directly. If we do that, we don't want to prepend any module reference information to the message.
  _constructMessage (...args) {
    return this._loggerInstance === ROOT_LOGGER
      ? args
      : [this._prefix, ...args]
  }
}

/**
 * All of these fields are to maintain backwards compatibility
 */
Logger.prototype.mock = mock
Logger.prototype.addSanitizedKeys = sanitize.addSanitizedKeys

module.exports = Logger
